export const en = {
    'button-cancel': 'Cancel',
    'button-submit': 'Apply'
};
